import { render, staticRenderFns } from "./FooterSimple.vue?vue&type=template&id=b5cc0d3a&"
import script from "./FooterSimple.vue?vue&type=script&lang=ts&"
export * from "./FooterSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports